import { ComboBoxInputOption } from '@wix/thunderbolt-components';
import classNames from 'classnames';
import * as React from 'react';
import { IDesignableListProps } from '../../ComboBoxInput/ComboBoxInput.types';
import { testIds } from '../../ComboBoxInput/constants';
import { noop } from '../../ComboBoxInput/utils';
import style from './style/ComboBoxInputListModal.scss';

const ComboBoxInputListModal: React.FunctionComponent<IDesignableListProps> =
  props => {
    const { id, value, options, onSelectedOptionChange = noop } = props;

    const designableListRef = React.useRef<HTMLDivElement>(null);
    const firstOptionRef = React.useRef<HTMLDivElement>(null);
    const selectedOptionRef = React.useRef<HTMLDivElement>(null);
    const [hoveredOptionIndex, setHoveredOptionIndex] = React.useState(-1);

    const _handleOptionMouseEnter = (index: number) => {
      setHoveredOptionIndex(index);
    };

    const _handleOptionMouseLeave = () => {
      setHoveredOptionIndex(-1);
    };

    const _handleOptionClick = (option: ComboBoxInputOption) => {
      onSelectedOptionChange(option.value);
    };

    React.useEffect(() => {
      const scrollToElem = selectedOptionRef.current || { offsetTop: 0 };
      const designableListElem = designableListRef.current;

      if (designableListElem) {
        designableListElem.scrollTop = scrollToElem.offsetTop;
      }
    }, []);

    const selectedOptionIndex = React.useMemo(
      () => options.findIndex(option => option.value === value),
      [options, value],
    );

    const getOptionRef = (optionIDX: number) =>
      selectedOptionIndex === optionIDX
        ? selectedOptionRef
        : optionIDX === 0
        ? firstOptionRef
        : undefined;

    return (
      <div
        className={style.designableListWrapper}
        data-testid={testIds.designableListWrapper}
      >
        <div
          id={`listModal_${id}`}
          ref={designableListRef}
          className={style.designableList}
        >
          {options.map((option, idx) => (
            <div
              key={idx}
              ref={getOptionRef(idx)}
              className={classNames(style.option, {
                [style.hovered]: hoveredOptionIndex === idx,
              })}
              onClick={() => _handleOptionClick(option)}
              onMouseEnter={() => _handleOptionMouseEnter(idx)}
              onMouseLeave={() => _handleOptionMouseLeave()}
              data-testid={testIds.designableListOption}
            >
              <div className={style.optionText}>{option.text}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

export default ComboBoxInputListModal;
